import { Row, Col, Button } from 'reactstrap';
import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import AssetDetailsItem from './assetDetailsItem';
import Icon from '../common/containers/icon';
const AssetDetail = _ref => {
  let assetActions = _ref.assetActions,
    loading = _ref.loading,
    userID = _ref.userID,
    asset = _ref.asset;
  const details = asset.details,
    assetID = asset.id,
    coatingDFTFactorOutsideLimits = asset.coatingDFTFactorOutsideLimits,
    coatingDFTFactorWithinLimits = asset.coatingDFTFactorWithinLimits,
    coatingDFTToleranceHigh = asset.coatingDFTToleranceHigh,
    coatingDFTToleranceLow = asset.coatingDFTToleranceLow;
  const handleAddDetail = () => {
    const newDetails = JSON.parse(JSON.stringify(details));
    const createdDate = moment().utc().toISOString();
    newDetails.push({
      assetID,
      id: uuidV4().toUpperCase(),
      appCreatorID: userID,
      // logged in user
      appCreated: createdDate,
      created: createdDate,
      conditions: [],
      photos: []
    });
    assetActions.change(assetID, 'details', newDetails);
  };
  const handleRemoveDetail = detailIndex => {
    const newDetails = JSON.parse(JSON.stringify(details));
    newDetails.splice(detailIndex, 1);
    assetActions.change(assetID, 'details', newDetails);
  };

  // path includes detail/photo/coating index(es)
  const handleChangeDetail = (path, value) => assetActions.change(assetID, path, value);
  const coatingDetails = {
    coatingDFTFactorOutsideLimits,
    coatingDFTFactorWithinLimits,
    coatingDFTToleranceHigh,
    coatingDFTToleranceLow
  };
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Detail Descriptions"), /*#__PURE__*/React.createElement("hr", null), (details || []).map((nextDetail, detailIndex) => /*#__PURE__*/React.createElement(AssetDetailsItem, {
    detailIndex: detailIndex,
    detail: nextDetail,
    key: nextDetail.id,
    loading: loading,
    userID: userID,
    coatingDetails: coatingDetails,
    onChange: handleChangeDetail,
    onRemove: handleRemoveDetail,
    serverUpload: assetActions.serverUpload
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: handleAddDetail,
    className: "float-md-right form-control t-ad-add-detail tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " Add Detail"))));
};
AssetDetail.propTypes = {
  loading: PropTypes.bool.isRequired,
  userID: PropTypes.string.isRequired,
  asset: PropTypes.shape({
    id: PropTypes.string,
    details: PropTypes.arrayOf(PropTypes.shape({})),
    coatingDFTFactorOutsideLimits: PropTypes.number,
    coatingDFTFactorWithinLimits: PropTypes.number,
    coatingDFTToleranceHigh: PropTypes.number,
    coatingDFTToleranceLow: PropTypes.number
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func,
    serverUpload: PropTypes.func
  }).isRequired
};
export default AssetDetail;